import $ from 'cash-dom';
import Ajax from "./ajax";

const Recaptcha = {
    init() {
        if (typeof grecaptcha !== 'undefined') {
            grecaptcha.enterprise.ready(async () => {
                const token = await grecaptcha.enterprise.execute('6Le6VJQrAAAAABTXop5wm_mXOCdWYmm411pHCU2n', {action: 'LOGIN'});

                if (token) {
                    Ajax.post(ajaxurl, {
                        action: 'recaptcha-verify',
                        token: token
                    }, function (response) {
                        if (response && response['success'] === 0) {
                            let links = $('a, [data-href]');

                            if (links && links.length) {
                                for (let i = 0; i < links.length; i++) {
                                    let link = $(links[i]),
                                        hrefAttr = null;

                                    if (typeof link.attr('href') !== 'undefined') {
                                        hrefAttr = 'href';
                                    } else if (typeof link.attr('data-href') !== 'undefined') {
                                        hrefAttr = 'data-href';
                                    }

                                    if (hrefAttr) {
                                        let href = link.attr(hrefAttr);

                                        if (href && href.indexOf('/go/vendor/') > 0) {
                                            href = href + '&bga=1';
                                            link.attr(hrefAttr, href);
                                        }
                                    }
                                }
                            }
                        }
                    }, 'json').fail(function (err) {
                    });
                }
            });
        }
    }
}

export default Recaptcha;